import { useNavigate } from 'react-router-dom';

import Layout from '../../introGameLayout/layout';
import './styles.css';

const exercises = [
  {
    title: 'Classification',
    color: '#FAEDED',
    items: [
      'The Basics',
      'Classified Balanced Sheet',
      'Multi-Step Income Statement',
      'Real Companies'
    ]
  },
  {
    title: 'Normal Balance',
    color: '#FFF8EB',
    items: [
      'The Basics',
      'Contra-Accounts'
    ]
  },
  {
    title: 'Balanced Equation',
    color: '#EBF2FF',
    items: [
      'Increase/Decrease',
      'Debit/Credit',
      'Income Statement Impact'
    ]
  },
  {
    title: 'Principles',
    color: '#ECF6F7',
    items: [
      'Revenue Recognition',
      'Expense Recognition',
      'Assumptions, Principles, and Constraints'
    ]
  }
];

export default function AllExercises() {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/instructor/settings/assignments', { state: { startTour: true } });
  };

  return (
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      className="instructor-onboarding-layout"
    >
      <div className="onboarding-all-exercises">
        <h1>Here are Our Exercises at a Glance</h1>
        <div className="onboarding-all-exercises-divider"></div>
        <div className="onboarding-all-exercises-grid">
          {exercises.map((exercise, index) => (
            <div key={index} className="onboarding-all-exercises-column">
              <div className="onboarding-all-exercises-header" style={{ backgroundColor: exercise.color }}>
                {exercise.title}
              </div>
              <ul>
                {exercise.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="onboarding-all-exercises-bonus">
          <strong>Bonus:</strong> Review Session Challenges
        </p>
        <button className="onboarding-all-exercises-button" onClick={handleButtonClick}>
          I'm ready to Explore More
        </button>
      </div>
    </Layout>
  );
}
